import type { AdaptGameOptions } from '@/logic/game-adapter/adapt-game';
import type { PRISMIC_ZONE_LAYOUT } from '@/app/constants/zone';
import type { Game } from '@/types/games';
import type { ClientGameContext } from './client-game-context';
import { getZoneGames } from './zone-games';

/** Adapts a raw game list (no zone wrapper) for client feature UIs. */
export const parseGamesList = (
    games: Game[],
    gridLayout: PRISMIC_ZONE_LAYOUT,
    ctx: ClientGameContext,
    options?: Omit<AdaptGameOptions, 'region' | 'isMobile'>
) => getZoneGames(games, gridLayout, { ...ctx, ...options });
